module.exports = __webpack_public_path__ + "static/media/adesivo_hd.44ed866b.png";